var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  style: {
    margin: "auto",
    background: "none",
    display: "block",
    shapeRendering: "auto"
  },
  width: "44px",
  height: "44px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8888888888888888s",
  repeatCount: "indefinite"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(40 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.7777777777777778s",
  repeatCount: "indefinite"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(80 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5555555555555556s",
  repeatCount: "indefinite"
})))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(160 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.4444444444444444s",
  repeatCount: "indefinite"
})))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(200 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
})))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.2222222222222222s",
  repeatCount: "indefinite"
})))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(280 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.1111111111111111s",
  repeatCount: "indefinite"
})))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(320 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47.5,
  y: 20,
  rx: 2.5,
  ry: 2.56,
  width: 5,
  height: 16,
  fill: "#4585ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})))));
export default SvgSpinner;